import React from "react";
import "./style.css";
import TemporaryDrawer from "./drawer";
import Button from "../button";
import ThemeSwitch from "../ThemeSwitch";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useThemeContext } from "../../../context/ThemeContext";

function Header() {
  const { darkMode, toggleTheme } = useThemeContext();

  const changeMode = () => {
    toggleTheme();
    toast.success("Theme Changed!", { toastId: "theme" });
  };

  return (
    <header className="header">
      <button type="button" data-text="Awesome" className="header-brand">
        <span className="actual-text">&nbsp;TrackCryptoPro.&nbsp;</span>
        <span className="hover-text" aria-hidden="true">
          &nbsp;TrackCryptoPro.&nbsp;
        </span>
      </button>

      <div className="links">
        <ThemeSwitch checked={darkMode} onChange={() => changeMode()} />
        <Link to={"/"} className="link" href="/">
          Home
        </Link>
        <Link className="link" to={"/watchlist"}>
          Watchlist
        </Link>
        <Link className="link" to={"/compare"}>
          Compare
        </Link>
        <Link className="button-link" to={"/dashboard"}>
          <Button
            text="Dashboard"
            onClick={() => console.log("button clicked")}
            outLined={false}
          />
        </Link>
      </div>
      <div className="mobile-drawer">
        <TemporaryDrawer />
      </div>
    </header>
  );
}

export default Header;
